import {ChangePasswordRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/ChangePasswordRequest';
import {EditProfileRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/EditProfileRequest';
import {LoginRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/LoginRequest';
import {NewPasswordRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/NewPasswordRequest';
import {RegisterRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/RegisterRequest';
import {ResetPasswordEmailRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/ResetPasswordEmailRequest';
import {CheckResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/CheckResponse';
import {ProfileResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/ProfileResponse';
import {TokenResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/TokenResponse';
import {UserResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/UserResponse';
import {NoExpectedResponse} from '@mintdata-wsp/common/controllers/network/generated/WspAPI';
import {API} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';

export class ProfileController
{
    public login(request:LoginRequest):Promise<ProfileResponse>
    {
        return API.profile.login(request);
    }

    public tokenSignIn(token:String):Promise<ProfileResponse>
    {
        return API.profile.tokenSignIn(token);
    }

    public register(request:RegisterRequest):Promise<ProfileResponse>
    {
        return API.profile.register(request);
    }

    public editProfile(request:EditProfileRequest):Promise<UserResponse>
    {
        return API.profile.editProfile(request);
    }

    public resetPassword(request:ResetPasswordEmailRequest):Promise<NoExpectedResponse>
    {
        return API.profile.resetPassword(request);
    }

    public newPassword(request:NewPasswordRequest):Promise<ProfileResponse>
    {
        return API.profile.newPassword(request);
    }

    public checkResetToken(token:string):Promise<CheckResponse>
    {
        return API.profile.checkResetToken(token);
    }

    public changePassword(request:ChangePasswordRequest):Promise<TokenResponse>
    {
        return API.profile.changePassword(request);
    }
}
